
    import { Component, Vue } from 'nuxt-property-decorator';

    @Component
    export default class BlockBorder extends Vue {}
